import { mapMediaVariants } from '@/common/media';

import type { GalleryImage, GalleryImageDto } from './gallery.dto';

export const mapGalleryImage = ({
  event_id,
  event_name,
  file_id,
  user_id,
  link,
  content_type,
  created_at,
  updated_at,
  id,
  name,
  size,
  media_status,
  variants,
}: GalleryImageDto): GalleryImage => ({
  id,
  name,
  size,
  eventId: event_id,
  eventName: event_name ?? null,
  userId: user_id ?? null,
  fileId: file_id,
  link: link ?? '',
  contentType: content_type,
  createdAt: created_at,
  updatedAt: updated_at,
  mediaStatus: media_status ?? null,
  variants: mapMediaVariants(link, variants),
});
